import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'

class AssessmentsComparison extends Component {
  formatScore = (score, interpretation) => {
    const displayScore =
      score !== null && score !== undefined ? score : '—'

    return `${displayScore} [${interpretation || 'Not available'}]`
  }

  calculateChange = (latest, comparison) => {
    if (
      latest === null ||
      latest === undefined ||
      comparison === null ||
      comparison === undefined
    ) {
      return null
    }

    return latest - comparison
  }

  formatChange = change => {
    if (change === null || change === undefined) {
      return '—'
    }

    if (change > 0) {
      return `+${change}`
    }

    return change
  }

  getAssessmentComparison = () => {
    return[
      { // PHQ-9 //
        assessment: 'Depression',

        baseline: 14,
        baselineInterpretation: 'Moderate',
        previous: 1,
        previousInterpretation: 'Mild',
        previousTimepoint: 'Monthly 12',

        latest: 0,
        latestInterpretation: 'None',
        latestTimepoint: 'Monthly 13',
        baselineChange: 'Improved',
        recentChange: 'Improved',
      },
      { // ASRM //
        assessment: 'Mania',

        baseline: 6,
        baselineInterpretation: 'High probability',

        previous: 6,
        previousInterpretation: 'High probability',
        previousTimepoint: 'Monthly 12',

        latest: 10,
        latestInterpretation: 'High probability',
        latestTimepoint: 'Monthly 13',
        baselineChange: 'No change',
        recentChange: 'No change',
      },
      { // GAD-7 //
        assessment: 'Anxiety',

        baseline: 14,
        baselineInterpretation: 'Mild',

        previous: 0,
        previousInterpretation: 'Minimal',
        previousTimepoint: 'Monthly 12',

        latest: 0,
        latestInterpretation: 'Minimal',
        latestTimepoint: 'Monthly 13',
        baselineChange: 'Improved',
        recentChange: 'No change',
      },
      // 0-5: Generally good sleep quality, 6-21: Significant sleep difficulties
      { // PSQI //
        assessment: 'Sleep',

        baseline: 14,
        baselineInterpretation: 'Poor',

        previous: 5,
        previousInterpretation: 'Good',
        previousTimepoint: 'Monthly 12',

        latest: 6,
        latestInterpretation: 'Poor',
        latestTimepoint: 'Monthly 13',
        baselineChange: 'Improved',
        recentChange: 'Worsened',
        //0–5 = normal/good sleep quality, Above 5 = sleep difficulties/poor sleep quality
      },
      { // WHO-5 //
        assessment: 'Well-being',

        baseline: null,
        baselineInterpretation:
          'Not available',

        previous: 17,
        previousInterpretation: '',
        previousTimepoint: 'Monthly 12',

        latest: 20,
        latestInterpretation: '',
        latestTimepoint: 'Monthly 13',
        baselineChange: '',
        recentChange: '',
      },
    ]
  }

  render() {
    const assessmentComparison =
      this.getAssessmentComparison()

    return (
      <div className="small-12 columns">
        <div className="title6">
          Your Assessments
        </div>

        <table>
          <thead>
            <tr>
              <th>Assessment</th>
              <th>At Enrollment<br /><span style={styles.dateLabel}>07/16/2025</span></th>
              <th>Previous<br /><span style={styles.dateLabel}>07/13/2026</span></th>
              <th>Now<br /><span style={styles.dateLabel}>08/12/2026</span></th>
              <th>Change Since Enrollment</th>
            </tr>
          </thead>

          <tbody>
            {assessmentComparison.map(item => {
              const changeFromBaseline =
                item.latest !== null &&
                item.baseline !== null
                  ? item.latest - item.baseline
                  : null

              const recentChange =
                item.latest !== null &&
                item.previous !== null
                  ? item.latest - item.previous
                  : null

              const formatChange = value => {
                if (value === null) {
                  return '—'
                }

                return value > 0 ? `+${value}` : value
              }

              return (
                <tr key={item.assessment}>
                  <td>{item.assessment}</td>
                  <td>{item.baselineInterpretation}</td>
                  <td>{item.previousInterpretation}</td>
                  <td><strong>{item.latestInterpretation}</strong></td>
                  <td>
                    {item.baselineChange}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

const styles = {
  dateLabel: {
    fontSize: 11,
    fontWeight: 400,
    color: '#607d8b',
  },
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AssessmentsComparison)
